import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Header from './components/Navigation/Header/';
import Dashboard from './routes/dashboard/';
import Agent from './routes/agent/';
import ActivityByUserReport from './routes/reports/ActivityByUserReport/';
import ExecutivePerUserReport from './routes/reports/ExecutivePerUserReport/';
import ExecutiveSummaryReport from './routes/reports/ExecutiveSummaryReport/';
import EntriesByCategory from './routes/reports/EntriesByCategory/';
import EntriesPerHours from './routes/reports/EntriesPerHours/';
import EntriesDismissed from './routes/reports/EntriesDismissed/';
import UptimeReport from './routes/reports/UptimeReport/';
import ChangePassword from './routes/change-password/';
import Configuration from './routes/configuration/';
import Management from './routes/management/';
import Broadcast from './routes/broadcast/';
import Websocket from './routes/websocket/';
import AuthService from 'services/AuthService';

class App extends React.Component {
  render() {
    return (
      <div className="main-app-container">
        <section className="app-page-container">
          <Header/>

          <div className="app-content-wrapper">
            <div className="app-content pb-0 full-width">
              <Switch>
                <Route path={`${this.props.match.path}agent`} component={Agent}/>
                <Route
                  path={`${this.props.match.path}report/activityByUserReport`}
                 component={ActivityByUserReport}
                />
                <Route
                  path={`${this.props.match.path}report/executivePerUserReport`}
                  component={ExecutivePerUserReport}
                />
                <Route
                  path={`${this.props.match.path}report/executiveSummaryReport`}
                  component={ExecutiveSummaryReport}
                />
                <Route
                  path={`${this.props.match.path}report/entriesByCategory`}
                  component={EntriesByCategory}
                />
                <Route
                  path={`${this.props.match.path}report/entriesPerHours`}
                  component={EntriesPerHours}
                />
                <Route
                  path={`${this.props.match.path}report/entriesDismissed`}
                  component={EntriesDismissed}
                />
                <Route
                  path={`${this.props.match.path}report/uptimeReport`}
                  component={UptimeReport}
                />
                {( AuthService.getUserRole().isTechAdmin || AuthService.getUserRole().isFunctAdmin || AuthService.getUserRole().isAdmin ) &&
                <Route path={`${this.props.match.path}configurations`} component={Configuration}/>}
                {( AuthService.getUserRole().isSupervisor || AuthService.getUserRole().isTechAdmin || AuthService.getUserRole().isAdmin ) &&
                <Route path={`${this.props.match.path}management`} component={Management}/>}
                {( AuthService.getUserRole().isBroadcast || AuthService.getUserRole().isAdmin ) &&
                <Route path={`${this.props.match.path}broadcast`} component={Broadcast}/>}
                <Route path={`${this.props.match.path}change-password`} component={ChangePassword}/>
                <Route path={`${this.props.match.path}websocket`} component={Websocket}/>
                <Route path={`${this.props.match.path}`} component={Dashboard}/>
              </Switch>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

module.exports = App;



// WEBPACK FOOTER //
// ./routes/app/index.js